import { Head } from "@inertiajs/react";

const LegalMention = () => {
  return (
    <>
      <Head title="Mentions légales - Review car" />
      <h1 className="text-center lg:max-w-[75%] mx-auto mt-10 mb-10">
        Mentions légales
      </h1>
      <div className="max-w-screen-lg mx-auto px-2">
        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          1. Éditeur du site
        </h4>
        <p className="mb-4">
          Le site internet www.review-car.com (ci-après le « Site ») est édité
          par :
          <br />
          Qualimetrie
          <br />
          Forme juridique : Société par actions simplifiée
          <br />
          Capital social : 37000 €
          <br />
          Siège social : 6 avenue de Flandre – 59491 Villeneuve d’Ascq
          <br />
          RCS : 350 899 225 R.C.S. Lille Métropole
          <br />
          Numéro SIRET : 35089922500048
          <br />
          Numéro de TVA intracommunautaire : FR46350899225
          <br />
          Représentant légal : Bayart Emeric, PDG
          <br />
          Téléphone : +33 (0)3 20 81 90 44
          <br />
          E-mail : contact@review-car.com
        </p>
        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          2. Hébergeur
        </h4>
        <p className="mb-4">
          Le Site est hébergé par :
          <br />
          Scalingo
          <br />
          13 rue Jacques Peirotes, 67000 Strasbourg, France
          <br />
          <a
            href="https://scalingo.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://scalingo.com
          </a>
        </p>
        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          3. Objet du site
        </h4>
        <p className="mb-4">
          Le Site a pour objet de proposer un service :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>
              de <b>consultation</b> d’avis de consommateurs sur des véhicules
              (notes, commentaires, avis consolidés),
            </li>
            <li>
              de <b>recherche</b> de véhicules correspondant à certains
              critères,
            </li>
            <li>
              de <b>dépôt d’avis</b> par les utilisateurs, après identification
              du véhicule par sa plaque d’immatriculation. 
            </li>
          </ul>
          Les informations, avis et notes publiés sur le Site sont fournis par
          les utilisateurs et ont une vocation exclusivement informative. Ils ne
          constituent en aucun cas des conseils professionnels, techniques,
          mécaniques, financiers ou juridiques.
        </p>
        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          4. Acceptation des CGU
        </h4>
        <p className="mb-2">
          L’accès au Site et son utilisation impliquent l’acceptation sans
          réserve des présentes Conditions Générales d’Utilisation (CGU) et des
          mentions légales. 
        </p>
        <p className="mb-2">
          En naviguant sur le Site et/ou en déposant un avis, l’« Utilisateur »
          reconnaît avoir pris connaissance des présentes CGU et les accepter. 
        </p>
        <p className="mb-2">
          Qualimetrie SAS se réserve le droit de modifier à tout moment les
          présentes CGU. La version en vigueur est celle accessible en ligne à
          la date de navigation de l’Utilisateur.
        </p>
        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          5. Accès au site
        </h4>
        <p className="mb-4">
          L’accès au Site est réservé aux utilisateurs âgés de 18 ans et plus.
          <br />
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>
              L’accès au Site est gratuit (hors coûts de connexion et
              d’équipement, à la charge de l’Utilisateur).
            </li>
            <li>
              Qualimetrie SAS s’efforce d’assurer un accès 24h/24 et 7j/7, sans
              pour autant être tenue à une obligation de résultat.
            </li>
            <li>
              L’accès peut être interrompu, suspendu ou limité à tout moment,
              notamment pour maintenance, mise à jour, raisons techniques ou cas
              de force majeure.
            </li>
          </ul>
          <p>
            Qualimetrie SAS ne saurait être tenue responsable de tout dommage
            direct ou indirect résultant de l’indisponibilité du Site.
          </p>
        </p>
        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          6. Fonctionnement du service d’avis
        </h4>
        <p>
          <b>6.1. Consultation des avis</b>
          <br />
          <br />
          L’Utilisateur peut rechercher un véhicule et consulter :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>les avis individuels laissés par d’autres utilisateurs,</li>
            <li>les notes sur plusieurs critères (jusqu’à 10 critères),</li>
            <li>
              les moyennes ou scores consolidés calculés à partir des avis
              disponibles.
            </li>
          </ul>
          Les avis reflètent l’opinion personnelle de leurs auteurs sauf mention
          contraire explicite sur le Site.
          <br />
          <br />
          <b>6.2. Dépôt d’un avis – Plaque d’immatriculation</b>
          <br />
          <br />
          Pour déposer un avis, l’Utilisateur doit notamment :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>
              saisir la plaque d’immatriculation du véhicule concerné (champ
              obligatoire).
            </li>
            <li>renseigner les notes sur les critères proposés.</li>
            <li>rédiger éventuellement un commentaire.</li>
          </ul>
          La plaque d’immatriculation est utilisée uniquement afin :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>d’identifier de manière unique un véhicule pour l’avis,</li>
            <li>
              d’éviter la multiplication d’avis liés à la même immatriculation.
            </li>
          </ul>
          En conséquence :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>
              une plaque d’immatriculation déjà utilisée pour publier un avis ne
              peut pas être réutilisée sur le Site pour un autre avis ;
            </li>
            <li>
              l’Utilisateur s’engage à renseigner uniquement la plaque d’un
              véhicule qu’il possède, loue, conduit ou utilise légitimement, ou
              pour lequel il est habilité à donner un avis.
            </li>
          </ul>
          Qualimetrie SAS se réserve le droit de mettre en place des contrôles
          (automatisés ou manuels) pour détecter les abus (multiplication d’avis
          frauduleux, incohérences, etc.).
          <br />
          <br />
          <b>6.3. Caractère non contractuel des avis</b>
          <br />
          <br />
          Les avis, notes et informations véhiculées par le Site sont donnés à
          titre indicatif :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>
              ils ne constituent pas une garantie sur l’état d’un véhicule,
            </li>
            <li>
              ils ne lient ni Qualimetrie SAS, ni les autres utilisateurs,
            </li>
            <li>
              ils ne peuvent pas être assimilés à une certification, une
              expertise ou un contrôle technique.
            </li>
          </ul>
          Tout choix ou décision (achat, vente, location, réparation, etc.)
          relèvent de la seule responsabilité de l’Utilisateur.
        </p>
        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          7. Compte utilisateur
        </h4>
        <p className="mb-4">
          Pour certaines fonctionnalités, l’Utilisateur peut être amené à créer
          un compte avec :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>une adresse e-mail,</li>
            <li>un mot de passe,</li>
            <li>éventuellement d’autres informations d’identification.</li>
          </ul>
          L’Utilisateur s’engage à :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>fournir des informations exactes, à jour et complètes,</li>
            <li>garder confidentiels ses identifiants de connexion,</li>
            <li>
              assumer la responsabilité de toutes les actions effectuées via son
              compte.
            </li>
          </ul>
          Qualimetrie SAS se réserve le droit de suspendre ou supprimer tout
          compte en cas de non-respect des présentes CGU ou de comportement
          abusif.
        </p>
        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          8. Engagements et comportements de l’utilisateur
        </h4>
        <p className="mb-4">
          L’Utilisateur s’engage à utiliser le Site de manière loyale et
          conforme aux lois en vigueur, notamment à :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>
              ne pas usurper l’identité d’un tiers ou l’identité du propriétaire
              d’un véhicule,
            </li>
            <li>
              ne pas déposer d’avis manifestement mensongers ou trompeurs,
            </li>
            <li>
              ne pas détourner le Site à des fins publicitaires ou commerciales
              non autorisées,
            </li>
            <li>
              ne pas entraver le fonctionnement du Site (virus, attaques, etc.).
            </li>
          </ul>
          Concernant les contenus (avis / commentaires / notes) publiés,
          l’Utilisateur s’engage à ne pas :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>
              publier de propos diffamatoires, injurieux, haineux, racistes,
              xénophobes, sexistes, violents, obscènes ou contraires aux lois et
              règlements,
            </li>
            <li>
              porter atteinte à la vie privée ou aux données personnelles de
              tiers,
            </li>
            <li>
              porter atteinte à des droits de propriété intellectuelle (marques,
              photos, textes, etc.),
            </li>
            <li>
              publier de contenu à caractère publicitaire, promotionnel ou
              sponsorisé, sauf accord écrit de Qualimetrie SAS.
            </li>
          </ul>
          Qualimetrie SAS se réserve le droit de :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>
              supprimer tout contenu qui violerait les présentes CGU, la loi ou
              qu’elle jugerait inapproprié,
            </li>
            <li>
              prendre toute mesure utile (suspension, suppression d’accès,
              transmission aux autorités compétentes).
            </li>
          </ul>
        </p>
        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          9. Modération des avis
        </h4>
        <p className="mb-4">
          Les avis peuvent faire l’objet d’une modération a posteriori par
          Qualimetrie SAS, qui peut :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>supprimer ou anonymiser un avis,</li>
            <li>
              masquer des informations sensibles ou non pertinentes (ex :
              données personnelles, coordonnées, etc.),
            </li>
            <li>
              refuser la publication d’un avis ne respectant pas les règles
              ci-dessus.
            </li>
          </ul>
          Qualimetrie SAS n’est cependant tenue à aucune obligation de
          surveillance générale des contenus, mais peut agir spontanément ou sur
          notification d’un Utilisateur ou d’un tiers.
          <br />
          <br />
          Pour signaler un contenu manifestement illicite ou problématique,
          l’Utilisateur peut écrire à : contact@review-car.com .
        </p>
        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          10. Propriété intellectuelle
        </h4>
        <p className="mb-4">
          <b>10.1. Contenus de Qualimetrie et du Site</b>
          <br />
          Le Site et l’ensemble de ses éléments (structure, textes, graphiques,
          logos, images, vidéos, bases de données, logiciels, etc.), à
          l’exception des contenus générés par les Utilisateurs, sont la
          propriété exclusive de Qualimetrie SAS ou de ses partenaires et sont
          protégés par les lois relatives à la propriété intellectuelle. Toute
          reproduction, représentation, diffusion, adaptation, traduction,
          modification, exploitation, intégrale ou partielle, du Site ou de l’un
          de ses éléments, sans autorisation écrite préalable de Qualimetrie
          SAS, est strictement interdite.
          <br />
          <br />
          <b>10.2. Contenus publiés par les utilisateurs</b>
          <br />
          Les contenus (avis, commentaires, notes, etc.) publiés par les
          Utilisateurs restent leur propriété. En publiant un contenu sur le
          Site, l’Utilisateur accorde toutefois à Qualimetrie SAS une licence
          non exclusive, gratuite, mondiale et pour la durée légale des droits,
          l’autorisant à :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>
              reproduire, représenter, adapter, modifier, traduire et exploiter
              ces contenus,
            </li>
            <li>dans le cadre du Site et de son fonctionnement,</li>
            <li>
              ainsi que dans le cadre de ses activités (communication,
              promotion, statistiques, etc.),
            </li>
            <li>sur tout support, actuel ou futur, et par tout moyen.</li>
          </ul>
          L’Utilisateur garantit disposer des droits nécessaires pour accorder
          cette licence à Qualimetrie SAS.
        </p>
        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          11. Données personnelles
        </h4>
        <p className="mb-4">
          <b>11.1. Responsable de traitement</b>
          <br />
          Le responsable de traitement des données personnelles collectées sur
          le Site est : Qualimetrie SAS – 6 avenue de Flandre, 59491 Villeneuve
          d’Ascq, France –dpo@qualimetrie.com.
          <br />
          <br />
          <b>11.2. Données collectées</b>
          <br />
          Dans le cadre de l’utilisation du Site, Qualimetrie SAS est
          susceptible de collecter :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>
              données d’identification : nom, prénom, adresse e-mail,
              identifiant, etc. (si fournies),
            </li>
            <li>
              données relatives au véhicule : plaque d’immatriculation, modèle,
              version, etc.,
            </li>
            <li>
              données liées aux avis : notes, commentaires, date de dépôt, etc.,
            </li>
            <li>
              données de connexion et de navigation : adresse IP, logs, cookies,
              traceurs, etc.
            </li>
          </ul>
          <br />
          La plaque d’immatriculation est utilisée uniquement pour :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>identifier un véhicule associé à un avis,</li>
            <li>
              empêcher la réutilisation d’une même plaque pour plusieurs avis
              sur le Site.
            </li>
          </ul>
          Elle n’est pas utilisée pour contacter le titulaire administratif du
          véhicule ni pour réaliser des démarches extérieures au Site.
          <br />
          <br />
          <b>11.3. Finalités et base légale</b>
          <br />
          <br />
          Les données sont traitées pour les finalités suivantes :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>gestion des avis et du fonctionnement du Site,</li>
            <li>modération et lutte contre les abus et fraudes,</li>
            <li>amélioration des services, statistiques et analyses,</li>
            <li>gestion des demandes de contact,</li>
            <li>respect des obligations légales et réglementaires.</li>
          </ul>
          Selon les cas, la base légale des traitements est :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>l’exécution d’un contrat (CGU),</li>
            <li>
              l’intérêt légitime de Qualimetrie SAS (amélioration du service,
              prévention des abus),
            </li>
            <li>le respect d’obligations légales.</li>
          </ul>
          <b>11.4. Durée de conservation</b>
          <br />
          Les données personnelles sont conservées pour une durée limitée,
          notamment :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>
              données liées aux avis : conservées tant que l’avis est en ligne,
              puis archivées à des fins probatoires pendant la durée de
              prescription applicable,
            </li>
            <li>
              données de connexion : conservées pour la durée nécessaire à la
              sécurité et à la prévention des abus, dans les limites prévues par
              la loi,
            </li>
            <li>
              données de contact : conservées le temps de traiter la demande et
              éventuellement archivées dans les délais légaux.
            </li>
          </ul>
          <b>11.5. Destinataires des données</b>
          <br />
          Les données peuvent être communiquées :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>aux services internes de Qualimetrie SAS,</li>
            <li>
              à des prestataires techniques (hébergeur, maintenance, outils
              d’analyse, etc.) agissant comme sous-traitants,
            </li>
            <li>
              aux autorités administratives ou judiciaires, sur demande ou
              injonction.
            </li>
          </ul>
          Les données ne sont pas vendues ni louées à des tiers à des fins
          commerciales, sans le consentement de l’Utilisateur.
          <br />
          <br />
          <b>11.6. Droits des utilisateurs</b>
          <br />
          Conformément au RGPD et à la loi Informatique et Libertés,
          l’Utilisateur dispose des droits suivants :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>droit d’accès à ses données,</li>
            <li>droit de rectification,</li>
            <li>droit à l’effacement (dans les limites légales),</li>
            <li>droit à la limitation du traitement,</li>
            <li>droit d’opposition pour motifs légitimes,</li>
            <li>droit à la portabilité des données fournies,</li>
            <li>
              droit de définir des directives post-mortem sur le sort de ses
              données.
            </li>
          </ul>
          L’Utilisateur peut exercer ses droits en écrivant à :
          dpo@qualimetrie.com ou 6 avenue de Flandre, 59491 Villeneuve d’Ascq,
          France, en précisant son identité (une pièce justificative peut être
          demandée) et l’objet de sa demande. En cas de désaccord persistant, il
          peut saisir la CNIL (www.cnil.fr).
          <br />
          L’Utilisateur garantit disposer des droits nécessaires pour accorder
          cette licence à Qualimetrie SAS.
        </p>
        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          12. Cookies et traceurs
        </h4>
        <p className="mb-4">
          Le Site utilise des cookies et technologies similaires pour :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>assurer son bon fonctionnement (cookies techniques),</li>
            <li>mesurer l’audience et les performances,</li>
            <li>éventuellement personnaliser l’expérience utilisateur.</li>
          </ul>
          Lors de la première visite, un bandeau d’information permet à
          l’Utilisateur de :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>accepter tous les cookies,</li>
            <li>refuser les cookies non strictement nécessaires,</li>
            <li>paramétrer ses choix.</li>
          </ul>
          L’Utilisateur peut modifier ses préférences à tout moment via :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>le module de gestion des cookies du Site,</li>
            <li>les paramètres de son navigateur internet.</li>
          </ul>
        </p>
        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          13. Liens hypertextes
        </h4>
        <p className="mb-4">
          Le Site peut contenir des liens vers des sites tiers. Qualimetrie SAS
          ne contrôle pas ces sites et ne saurait être responsable de leur
          contenu, de leur fonctionnement ou du traitement de données
          personnelles qu’ils mettent en œuvre.
          <br />
          <br />
          La création de liens vers le Site est autorisée sous réserve de :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>
              ne pas porter atteinte à l’image ou à la réputation de Qualimetrie
              SAS et de review-car.com,
            </li>
            <li>
              ne pas laisser croire à une association, un partenariat ou un
              parrainage inexistant.
            </li>
          </ul>
          Qualimetrie SAS se réserve le droit de demander la suppression de tout
          lien ne respectant pas ces conditions.
        </p>
        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          14. Responsabilité
        </h4>
        <p className="mb-4">
          <b>14.1. Utilisation du site</b>
          <br />
          L’Utilisateur utilise le Site sous sa seule responsabilité.
          Qualimetrie SAS ne garantit ni l’exactitude, ni l’exhaustivité, ni la
          mise à jour des informations et avis publiés. Qualimetrie SAS ne
          pourra être tenue responsable :
          <ul className="list-disc list-inside mb-4 pl-4 mt-2">
            <li>
              des décisions prises par l’Utilisateur sur la base des
              informations du Site,
            </li>
            <li>
              des dommages indirects (perte de chance, perte de profit, etc.),
            </li>
            <li>
              des dommages résultant de l’accès ou de l’impossibilité d’accès au
              Site,
            </li>
            <li>
              des dommages causés à l’équipement de l’Utilisateur (virus, etc.),
              ce dernier restant responsable de la protection de son matériel et
              de ses données.
            </li>
          </ul>
          <b>14.2. Contenus publiés par les utilisateurs</b>
          <br />
          Les contenus publiés par les Utilisateurs sont sous leur entière
          responsabilité. Qualimetrie SAS ne peut être tenue pour responsable
          des propos tenus ou informations communiquées dans ces contenus.
          <br />
          <br />
          En cas de litige lié à un contenu utilisateur, l’auteur du contenu
          sera seul responsable.
        </p>
        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          15. Droit applicable et juridiction compétente
        </h4>
        <p className="mb-4">
          Les présentes mentions légales et CGU sont régies par le droit
          français.
          <br />
          <br />
          En cas de litige relatif à l’interprétation ou à l’exécution des
          présentes et à défaut de solution amiable, les tribunaux compétents
          seront ceux du ressort du siège social de Qualimetrie SAS, sauf
          dispositions légales impératives contraires.
        </p>
        <h4 className="primary-color font-bold text-xl mb-4 mt-2">
          16. Contact
        </h4>
        <p className="mb-4">
          Pour toute question relative au Site, aux mentions légales, aux CGU ou
          à vos données personnelles,
          <br />
          vous pouvez contacter :
          <br />
          <b>Qualimetrie SAS</b>
          <br />
          6 avenue de Flandres
          <br />
          59491 Villeneuve d’Ascq
          <br />
          E-mail : contact@review-car.com
        </p>
      </div>
    </>
  );
};

export default LegalMention;
